module.exports = __webpack_public_path__ + "img/orange_096.77a93f85.png";